import { IPreloadedState } from 'shared/types/redux';

export const selectCoworkingNames = (state: IPreloadedState) => state.tags.meta.coworkingNames;
